export enum PermissionName {
  reports = 'reports',
  divisions = 'divisions',
  communities = 'communities',
  plans = 'plans',
  homes = 'homes',
  phases = 'phases',
  documents = 'documents',
  schedule = 'schedule',
  contacts = 'contacts',
  messages = 'messages',
  users = 'users'
}
